import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'

import { BUSINESS_PRIORITIES_TRANSLATION_KEYS as KEYS } from '../../configs/translations'
import { selectBusinessPrioritiesUserInfo, useBusinessPrioritiesView } from '../../model'
import { BusinessPrioritiesHeader } from '../businessPrioritiesHeader'

import styles from './BusinessPrioritiesListHeader.module.scss'

interface IBusinessPrioritiesListHeaderProps {
  fYear: number
  publishDate?: string
  isReadOnly?: boolean
  className?: string
}
export const BusinessPrioritiesListHeader: FC<IBusinessPrioritiesListHeaderProps> = ({
  fYear,
  publishDate = '',
  isReadOnly = false,
  className,
}) => {
  const userInfo = useSelector(selectBusinessPrioritiesUserInfo)
  const isWorldWide = useMemo(() => userInfo?.viewType === 'WorldWide', [userInfo])
  const market = useMemo(() => userInfo?.market, [userInfo])
  const { goToEditView } = useBusinessPrioritiesView()

  const currentFyearTitle = useMemo(() => `FY${fYear.toString().slice(-2)}`, [fYear])
  // const previousFyearTitle = useMemo(() => `FY${(fYear - 1).toString().slice(-2)}`, [fYear])

  const title = (
    <>
      <Translation text={KEYS.listHeader.title} />
      {isWorldWide && (
        <div className={styles.marketWrapper}>
          <span>{`—`}</span>
          <Translation span text={KEYS.listHeader.titleWorldwide} />
        </div>
      )}
      {!isWorldWide && market && (
        <div className={styles.marketWrapper}>
          <span>{`—`}</span>
          <span>{market}</span>
        </div>
      )}
    </>
  )

  const subtitle = (
    <Translation
      text={isWorldWide ? KEYS.listHeader.subtitleWorldwide : KEYS.listHeader.subtitleMarket}
      replaceParams={[
        { value: currentFyearTitle, key: '{fYear}' },
        { value: publishDate, key: '{fullDate}' },
      ]}
    />
  )

  const addActions = isWorldWide ? (
    <>
      {/* <Button icon="kbase kbase-reload" variant="outlined">
        <Translation
          text={KEYS.listHeader.cloneFromPreviousYear}
          replaceParams={[{ value: previousFyearTitle, key: '{fYear}' }]}
        />
      </Button> */}

      {/* <Button icon="kbase kbase-search" variant="outlined">
        <Translation
          text={KEYS.listHeader.marketOverrides}
          replaceParams={[{ value: '(3)', key: '{count}' }]}
        />
      </Button> */}

      <Button color="primary" icon="kbase kbase-add" variant="contained" onClick={goToEditView}>
        <Translation text={KEYS.listHeader.addBusinessPriorityWorldwide} />
      </Button>
    </>
  ) : (
    <Button
      color="primary"
      icon="kbase kbase-add"
      variant="contained"
      onClick={() => goToEditView()}
    >
      <Translation text={KEYS.listHeader.addMarketBp} />
    </Button>
  )

  return (
    <BusinessPrioritiesHeader
      title={title}
      subtitle={subtitle}
      actions={isReadOnly ? undefined : addActions}
      className={className}
    />
  )
}

BusinessPrioritiesListHeader.displayName = 'BusinessPrioritiesListHeader'

export default BusinessPrioritiesListHeader
